import React, { useState, useEffect } from "react";
import "./CourseSyllabus.css";
import Popupboxx from "../Popupbox/Popupbox";
import AOS from "aos";
import "aos/dist/aos.css";

const modules = [
  {
    title: "Introduction to Frontend Development",
    points: [
      "What is Frontend Development and its scope",
      "How websites and web apps work",
      "Client-side vs server-side concepts",
      "Overview of modern frontend ecosystem",
    ],
  },
  {
    title: "HTML Fundamentals",
    points: [
      "HTML structure and elements",
      "Forms, inputs, and validation basics",
      "Semantic HTML best practices",
      "Building basic web page layouts",
    ],
  },
  {
    title: "CSS & Responsive Design",
    points: [
      "CSS selectors, properties, and styling",
      "Flexbox and Grid layout systems",
      "Responsive design with media queries",
      "Mobile-first design approach",
    ],
  },
  {
    title: "JavaScript Essentials",
    points: [
      "Variables, functions, and ES6 concepts",
      "DOM manipulation and events",
      "Asynchronous JavaScript (Promises, async/await)",
      "API calls using fetch/Axios",
    ],
  },
  {
    title: "React.js Development",
    points: [
      "Introduction to React and components",
      "Props, state, and hooks",
      "React Router for navigation",
      "Building reusable UI components",
    ],
  },
  {
    title: "Styling Frameworks",
    points: [
      "Bootstrap for responsive UI",
      "Tailwind CSS utility-first approach",
      "Component-based styling strategies",
      "UI consistency and design systems",
    ],
  },
  {
    title: "Version Control & Tools",
    points: [
      "Git and GitHub basics",
      "Branching and collaboration workflow",
      "Browser DevTools usage",
      "Code optimization and debugging",
    ],
  },
  {
    title: "API Integration",
    points: [
      "Consuming REST APIs in frontend apps",
      "Handling JSON data",
      "Authentication handling basics",
      "Error handling in API calls",
    ],
  },
  {
    title: "Projects & Deployment",
    points: [
      "Building real-time frontend projects",
      "Portfolio website development",
      "State management basics",
      "Deployment using Netlify/Vercel",
    ],
  },
];

function CourseSyllabus() {
  const [activeModule, setActiveModule] = useState(0);
  const [isMobile, setIsMobile] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  // Detect screen size
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize(); // check on load
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

   useEffect(() => {
      AOS.init({ duration: 800, once: true });
    }, []);

  return (
    <>
    <section className="syllabus-section">
      <div className="container">
        <div className="headlines-for-all">
          <h4   data-aos="fade-up">
            <span>Course </span> Syllabus
          </h4>
          <p  data-aos="fade-up">
            Explore our comprehensive Frontend syllabus — built for
            real-world projects, hands-on learning, and 100% job readiness.
          </p>
        </div>


        {/* ---------- Desktop Tabs ---------- */}
        {!isMobile && (
          <>
            <div className="custom-btn-group "   data-aos="fade-up">
              {modules.map((m, index) => (
                <button
                  key={index}
                  className={`custom-btn ${activeModule === index ? "active" : ""
                    }`}
                  onClick={() => setActiveModule(index)}
                >
                  Module {index + 1}
                </button>
              ))}
            </div>

            <div className="custom-module-container"   data-aos="fade-up">
              <div className="custom-module-box active">
                <h4>{modules[activeModule].title}</h4>
                <ul className="ul-list-module">
                  {modules[activeModule].points.map((p, i) => (
                    <li key={i}>{p}</li>
                  ))}
                </ul>
              </div>
            </div>
          </>
        )}

        {/* ---------- Mobile Accordion (FAQ Style) ---------- */}
        {isMobile && (
          <div className="faq-container-course"   data-aos="fade-up">
            {modules.map((m, index) => (
              <div
                key={index}
                className={`faq-item-course ${activeModule === index ? "open" : ""
                  }`}
              >
                <button
                  className="faq-question-course"
                  onClick={() =>
                    setActiveModule(activeModule === index ? null : index)
                  }
                >
                  {m.title}
                  <span className="faq-icon-course">
                    {activeModule === index ? "−" : "+"}
                  </span>
                </button>

                <div
                  className="faq-answer-course"
                  style={{
                    maxHeight: activeModule === index ? "400px" : "0px",
                  }}
                >
                  <ul>
                    {m.points.map((p, i) => (
                      <li key={i}>{p}</li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="btn-center"   data-aos="fade-up">
          <button className="download-btn" onClick={() => setIsPopupOpen(true)}>Download Syllabus</button>
        </div>
      </div>
    </section>

  
       <Popupboxx
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
      />
      </>
  );
}

export default CourseSyllabus;
